export default __webpack_public_path__ + "static/Pressure_Plate-53c8c677dbf8eae5473388ed1fdcb341.png";